import React from 'react';

/**
 * KPI tile (mockups 5a / 3a / data-source-hub): optional colored dot + uppercase
 * label, big value, small sub line. Parent owns the grid layout.
 */
function StatTile({ label, value, sub, dot, valueColor, testId }) {
  return (
    <div className='sg-stat-tile' style={{ padding: '14px 16px' }} data-testid={testId}>
      <div className='sg-stat-tile__label'>
        {dot && <span style={{ width: 8, height: 8, borderRadius: '50%', background: dot, flex: 'none' }} />}
        {label}
      </div>
      <div className='sg-stat-tile__value' style={{ fontSize: 22, ...(valueColor ? { color: valueColor } : {}) }}>
        {value}
      </div>
      {sub != null && <div className='sg-stat-tile__sub'>{sub}</div>}
    </div>
  );
}

export default StatTile;
